/**
 *  유저 상세 > 팔로우한 태그 정보 > 팔로우 태그 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  태그 ID
   */
  tagId: null,
  /**
   *  태그명
   */
  tagName: null,
  /**
   *  태그 그룹
   */
  tagGroupList: null,
  /**
   *  최신 팔로우 추가 일시
   */
  lastFollowTagDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 팔로우한 태그 정보 > 팔로우 태그 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_SORT_OPTION_MODEL = [
  {
    id: 'lastFollowTagDate',
    desc: true,
  },
];
